<template>

    <router-view></router-view>

</template>

<script>
export default {
  name: 'App'
}
</script>
<style lang="scss">
:root {
  --primary: #3373DC;
  --mutedprimary: #0259A1;
  --secondary: #FFF;
  --dark-text: #212121;
  --medium-text: #555555;
  --light-text: #7c7c7c;
  --green: #73BA20;
  --yellow: #f5C32E;
  --red: #F23350;
  --background-grey: #EFEFEF;
  --lightergrey: #f1f1f1;
  --alttablerow: #F7F7F7;
  --button-gradient-start-green: #85CA2C;
  --invoice-heading-bg: #F2F2F2;
  --totals-button: #1C4680;
  --background-white: #f6f8fa;
}
// TODO hack to get rid of the emulator warning until it becomes a flag
// https://github.com/firebase/firebase-tools/issues/2773
.firebase-emulator-warning{
  display:none;
}
@font-face {
    font-family: 'suisse_intl';
    src: url('/fonts/suisseintl-book-webfont.woff2') format('woff2'),
         url('/fonts/suisseintl-book-webfont.woff') format('woff');
    font-weight: 400;
    font-style: normal;
}

@font-face {
    font-family: 'suisse_intl';
    src: url('/fonts/suisseintl-medium-webfont.woff2') format('woff2'),
         url('/fonts/suisseintl-medium-webfont.woff') format('woff');
    font-weight: 500;
    font-style: normal;
}

@font-face {
    font-family: 'suisse_intl';
    src: url('/fonts/suisseintl-semibold-webfont.woff2') format('woff2'),
         url('/fonts/suisseintl-semibold-webfont.woff') format('woff');
    font-weight: 700;
    font-style: normal;
}

@font-face {
    font-family: 'suisse_intl';
    src: url('/fonts/suisseintl-bold-webfont.woff2') format('woff2'),
         url('/fonts/suisseintl-bold-webfont.woff') format('woff');
    font-weight: 900;
    font-style: normal;
}
  body{
    font-family:"suisse_intl", Arial !important;
    font-weight:400;
  }
  .display-4, .main-headline {
    font-family:"suisse_intl", Arial !important;
    font-size:4.2rem !important;
    letter-spacing:0 !important;
    font-weight:700;
  } // - Good for <h1>
  .display-3, .page-header {
    font-family:"suisse_intl", Arial !important;
    font-size:3rem !important;
    letter-spacing:0 !important;
    font-weight:700;
    line-height:1 !important;
  } // - Good for <h2>
  .display-4{
    font-family:"suisse_intl", Arial !important;
    font-size:2.3rem !important;
    letter-spacing:0 !important;
    font-weight:700;
    line-height:1 !important;
  } // - Good for <h2>
  .headline, .title{
    font-family:"suisse_intl", Arial !important;
    font-size:2.1rem !important;
    letter-spacing:0 !important;
    font-weight:700;
  } //- Good for <h5>
  .subheading{
    font-family:"suisse_intl", Arial !important;
    font-size:1.4rem !important;
    letter-spacing:0 !important;
    font-weight:700;
  } //- Good for supporting text
  .body-2{
    font-family:"suisse_intl", Arial !important;
    font-size:1.1rem !important;
    letter-spacing:0 !important;
    font-weight:700;
  } //- Regular body text with additional weight
  .body-1{
    font-family:"suisse_intl", Arial !important;
    font-size:1.1rem !important;
    letter-spacing:0 !important;
    font-weight:400;
  } //- Regular body text
  .body-small{
    font-family:"suisse_intl", Arial !important;
    font-size:.95rem !important;
    letter-spacing:0 !important;
    font-weight:400;
  }
  .caption{
    font-family:"suisse_intl", Arial !important;
    font-size:.9rem !important;
    letter-spacing:0 !important;
    font-weight:400;
    &.light{
      color:var(--light-text);
    }
    &.label-style{
      color: var(--light-text);
    }
    &.bold{
      font-weight:700;
      font-size:.85rem !important;

    }
    &.semi{
      font-weight:500;
    }
  } //- Smaller size text
  .body-smaller{
    font-family:"suisse_intl", Arial !important;
    font-size:.85rem !important;
    letter-spacing:0 !important;
    font-weight:400;
    line-height:1.6;
  }
  .body-tiny{
    font-family:"suisse_intl", Arial !important;
    font-size:.65rem !important;
    letter-spacing:0 !important;
    font-weight:400;
  }
  .subtle{
    color:var(--light-text);
    font-style:normal;
  }
  .bold{
    font-weight:700;
  }
  .xbold{
    font-weight:900;
  }
  .add-page-head{
    padding:16px 0 37px;
  }
  .v-btn{
    border-radius:3px;
    font-size:13px;
    text-transform:lowercase;
  }
  .action-button-padding{
    padding-left:20px;
    padding-right:20px;
  }
  .v-btn--round {
    border-radius:28px;
  }
  // BUG fixes odd overlay of .12 opacity which offsets the colour
  .v-btn.totalsbut:before {
    display:none;
  }
  .v-btn--floating{
    border-radius:50%;
  }
  .v-btn--small{
    font-size:14px;

  }
  .v-btn--medium{
    height:32px;
  }
  .v-btn--large{
    height:40px;
  }
  .v-btn--floating{
    width:30px;
    height:30px;
    &.v-btn--large{
      width:50px;
      height:50px;
    }
  }
  .v-item-group.v-bottom-nav .v-btn--active {
    color:var(--green);
  }
  .theme--light.v-bottom-nav .v-btn:not(.v-btn--active) {
    color:#fff !important;
  }
  .v-text-field input{
    font-size:1rem;
  }
  .v-textarea textarea{
    font-size:1rem;
    line-height:1.5;
    padding-top:20px;
    padding-bottom:20px;
  }
  .v-select__selection{
    font-size:1rem;
  }
  .v-input--selection-controls.v-input .v-label {
    font-size:1rem;
  }
  .v-input--slider .v-label{
    font-size:1rem;
  }
  .v-radio label.v-label{
    color:var(--dark-text);
  }
  .row{
    padding:0 !important;
  }
  .v-btn{
    margin-top:0;
    margin-bottom:0;
    margin:0;
  }
  // input text color
  .theme--light.v-input:not(.v-input--is-disabled) input,
  .theme--light.v-input:not(.v-input--is-disabled) textarea,
  .theme--light.v-select .v-select__selections
  {
    color:var(--dark-text);
    font-size:14px;
  }
  // nav rollover colour
  .theme--dark.v-list .v-list__tile--link:hover {
    background-color: rgba(0, 0, 0, 0.2);
  }

  // label color
  .theme--light.v-label{
    color:var(--light-text);
  }
  .fake-label{
    color:var(--light-text);
    font-size:12px;
    &.link{
      color:var(--primary);
      display:inline;
      cursor:pointer;
    }
  }
  .v-input--is-focused .v-label--active{
      color:var(--primary) !important;
  }
  // placeholder
  ::placeholder,
  .theme--light.v-input input::placeholder,
  .theme--light.v-input textarea::placeholder
  {
    color:var(--light-text);
    opacity:1;
    font-family:"suisse_intl", Arial !important;
    font-size:.95rem !important;
    letter-spacing:0 !important;
    font-weight:400;

  }
  .v-card, .b-shadow{
    box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.1);
  }
  .v-card--flat{
    box-shadow: none;
  }
  .theme--light.v-messages{
      color:var(--light-text);
  }
  .theme--light.v-table thead th {
      color: var(--dark-text);
  }
  table.v-table thead th:first-child{
    padding: 0 24px 0 16px !important;
  }
  .v-btn--floating.v-btn--small.extrasmall{
    width:30px;
    height:30px;
  }
  .v-timeline-item__dot{
    box-shadow:none;
  }
  .v-timeline:before{
    width:1px;
  }
  .theme--light.v-timeline .v-timeline-item__dot {
    background:#fff;
  }
  .v-timeline--dense .v-timeline-item__body{
    max-width: calc(100% - 40px);
  }
  .main-nav{
    padding:0;
  }
  .main-nav .v-toolbar__content{
    padding:0 12px;
  }

  .logo{
    max-width:90px;
    margin-top:10px;
  }
  .application{
    font-family:"suisse_intl", Arial !important;
    font-weight:400;
  }
  .application.theme--light{
    // NCCOLOUR
    background:var(--background-grey) !important;
    color:var(--dark-text);
  }
  .custom-loader {
    animation: loader 1s infinite;
    display: flex;
  }
  // field underlines
  .application .theme--light.input-group:not(.input-group--error) .input-group__details:before,
  .theme--light .input-group:not(.input-group--error) .input-group__details:before
  {
    color:var(--light-text);
  }
  // field hover underlines
  .input-group__details:after{
    color:var(--green) !important;
  }
  // currency prefix line up better
  .input-group--prefix .input-group--text-field__prefix{
    margin-top:0;
  }
  // more opaque not on tabs
  .v-tabs__item:not(.v-tabs__item--active){
    opacity:.4;
  }
  // table cell spacing in datatables
  table.table tbody td {
    height:60px !important;
  }
  // modal dialog
  .v-sheet{
    border-radius:7px;
  }
  .v-sheet.no-border{
    border-radius:0;
  }
  //modal padd
  // remove form padding in container
  .modal-pad{
    padding:25px;
  }
  // intro-modal class
  .intro-modal{
    border-radius:7px;
    // overflow:hidden;
  }
  .v-form>.container.modal-pad{
    padding:20px 32px;
  }
  // remove extra form padding
  .v-form>.container>.layout>.flex{
    padding:0;
  }
  // modal close

  .close-float-text{
    position:absolute;
    top:10px;
    right:20px;
    // text-transform: capitalize;
    &:hover{
      position:absolute;
    }
  }

  // tiny button used in invoice modals
  .tinybut{
    min-width:auto;
    font-size:13.3px;
    margin-right:0px;
    padding:0 15px;
  }

  // actions arrow for split button
  .actions-arrow.v-btn{
    min-width:0;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    // border-left:1px solid #fff !important;
    box-shadow: inset 7px 0 2px -7px rgba(0, 0, 20, 0.6);
    &.v-btn--right{
      right:17px;
    }
  }
  .v-icon.dropdown{
    width:20px;
  }

  .invoice-card{
    background: var(--background-grey);
    border-radius:7px;
    margin:20px 25px;
    padding:15px 15px 15px 15px;
    position:relative;
  }
  .invoice-card.shorten{

    overflow: hidden;
    height:120px;
  }
    .client-details-shorten{
      height:100px;
      overflow: hidden;
    }
  .client-details-shorten:after{
    content:'';
    width:100%;
    height:100%;
    position:absolute;
    left:0;
    top:0;
    background:linear-gradient(transparent 50px, var(--background-grey));
  }

  .small-switch.v-input--selection-controls.v-input .v-label {
    font-size: 12px;
  }

  .datatable tbody tr:nth-of-type(odd):not(.v-datatable__expand-row) {
  background-color: var(--alttablerow);
}
.datatable .theme--light.v-table tbody tr:not(:last-child) {
  border-bottom: none;
}

.modal-tabs a.v-tabs__item{
  padding:0;
}
.modal-tabs .v-tabs__item:not(.v-tabs__item--active) {
    opacity: 1 !important;
}

.tab-button, .done-button{
  text-transform:lowercase;
  padding:5px 23px;
  margin:0 3px;
  cursor:pointer;
  font-weight:500;
}
.tab-button{
  .xsOnly &{
    padding:5px 20px;
  }
}
.tab-button.disabled, .done-button.disabled{
  opacity:.5;
  cursor: not-allowed;
  background:var(--background-grey);
  border-radius: 28px;
}

.v-tabs__item--active .tab-button, .tab-button:hover, .done-button:hover{
  background:var(--background-grey);
  border-radius: 28px;
}
.v-tabs__item--active .tab-button.rounded, .tab-button.rounded:hover{
  border-radius:100%;
    margin:0 0px;

  padding-left:7px !important;
  padding-right:7px !important;

}

.edit-button{
  text-transform:lowercase;
  padding:3px 10px;
  margin:0 3px;
  cursor:pointer;
  font-weight:500;
  border-radius: 28px;
  background:var(--primary);
  color:#fff;
  font-size:12px;
  transition:.3s opacity linear;
}
.edit-button:hover{
  opacity:.8;
}

.v-overlay:before {
  background-color:#001627;
}

.app-panel {
  border-radius:16px;
}
#confetti-canvas {
  z-index: 4000;
}
.application--wrap{
 min-height:100dvh;
}

  // tour style overrides
  @-moz-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-webkit-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @-o-keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes loader {
    from {
      transform: rotate(0);
    }
    to {
      transform: rotate(360deg);
    }
  }

</style>
